export default __webpack_public_path__ + "static/media/arrow-right-blue.32bd2faa.svg";